// src/app/auth.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
declare const grecaptcha: any;

@Injectable({ providedIn: 'root' })

export class AuthService {
  // private backendUrl = 'http://localhost:3000/api/v1/auth';
  private backendUrl = 'https://analytics.dev.electrum.co/api/v1/auth';
  private scriptLoaded = false;
  captchaSiteKey = '6Le6KCgrAAAAAFTVUF2w0YKyz9CJfeAtEPEbsHI3'// Replace with your CAPTCHA site key
  siteKeyEnterprise = '6LcOSTYrAAAAAKsWtgOP8CffUJpbSAxvBzUjUgqP'
  constructor(private http: HttpClient) {}

  authenticate(formData:any, recaptchaToken: string) {
    const data = {
      password: formData.password,
      email: formData.email,
      phone: formData.phone,
      fname: formData.fname,
      lname: formData.lname,
      recaptchaToken,
      isEnterprise: true,
      action: 'signup'
    }
    return this.http.post(this.backendUrl, data);
  }

  login(formData:any, recaptchaToken: string) {
    const data = {
      password: formData.password,
      email: formData.email,
      simulateLowScore: formData.simulateLowScore,
      recaptchaToken
    }
    return this.http.post(this.backendUrl+'/login', data);
  }

  sendReferral(emails:any, recaptchaToken: string) {
    const data = {
      emails: emails,
      recaptchaToken
    }
    return this.http.post(this.backendUrl+'/sendReferral', data);
  }

  loadRecaptchaScript(useEnterprise: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded) return resolve();

      const script = document.createElement('script');
      script.src = useEnterprise
        ? `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKeyEnterprise}`
        : `https://www.google.com/recaptcha/api.js?render=${this.captchaSiteKey}`;
      script.async = true;
      script.onload = () => {
        this.scriptLoaded = true;
        resolve();
      };
      script.onerror = () => reject('Failed to load reCAPTCHA script.');
      document.head.appendChild(script);
    });
  }

  executeOld(isEnterprise: boolean, action: string): Promise<string> {
    let siteKey = this.captchaSiteKey;

    if (isEnterprise) {
      siteKey = this.siteKeyEnterprise;
    }
    return new Promise((resolve, reject) => {
      if (!(window as any).grecaptcha) return reject('reCAPTCHA not loaded');

      grecaptcha.ready(() => {
        grecaptcha
          .execute(siteKey, { action })
          .then((token: string) => resolve(token))
          .catch((err: any) => reject(err));
      });
    });
  }

  execute(isEnterprise: boolean, action: string): Promise<string> {
    const siteKey = isEnterprise ? this.siteKeyEnterprise : this.captchaSiteKey;

    return new Promise((resolve, reject) => {
      const grecaptchaObj = isEnterprise ? (window as any).grecaptcha.enterprise : (window as any).grecaptcha;

      if (!grecaptchaObj) return reject('reCAPTCHA not loaded');

      grecaptchaObj.ready(() => {
        grecaptchaObj
          .execute(siteKey, { action })
          .then((token: string) => resolve(token))
          .catch((err: any) => reject(err));
      });
    });
  }


}
